exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#header-component .nav-link {\n  cursor: pointer;\n}", ""]);

